import _ from "lodash";
import "./POIAdmin.scss";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import APIKeyEditView from "@/components/POI/APIKeyEditView/APIKeyEditView.vue";
import APIKeyList from "@/components/Common/APIKeyList/APIKeyList.vue";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { getPoisForConnectionMapping } from "@/helpers/poiHelper";
import { uploadFile } from "@/helpers/fileHelper";
import axios from "axios";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import {
  copyFileById,
  destroyFile,
  getPictureUrlDatePath,
  getTokenHeader
} from "@/helpers/commonHelper";
import { checkPlz } from "@/configuration/formConfigurations";
import DateInput from "@/components/Common/DateInput/DateInput.vue";

const defaultConfig = {
  salesSettings: {
    useSalesSettings: false,
    detailView: true,
    showPicture: true,
    showState: true,
    defaultPicture: { url: "" },
    sort: false
  },
  containByCategoryGroupIds: [],
  containByCategoryTypeIds: [],
  containByCategoryIds: [],
  containByFeatureIds: [],
  showReleased: true,
  showHighlightToTop: false,
  showHighlight: false,
  defaultSorting: false,
  newWidget: true,
  showPoiNews: true,
  newsStyle: "standard",
  displayFiltersOutlined: false,
  hideMapInDetailView: false,
  showCategoryOnGridCard: false,
  defaultDirection: false,
  hitsPerPage: 10,
  startPage: 1,
  startOffset: 0,
  outputLang: "",
  compactDetailView: false,
  displayMap: false,
  displayLocationZip: false,
  displayLocationDistrict: false,
  displayLocationCity: false,
  displayLocationStreet: false,
  displayLocationCountry: false,
  displayCurrentlyOpen: false,
  displayShortTitle: false,
  customFeatureGroups: [],
  customCategoryGroups: [],
  displaySubTitle: false,
  displayOnlyWithWebcams: false,
  enableRandomSorting: false,
  showMappingFieldFilter: false,
  showMap: false,
  hideBreadcrumb: false,
  hideFeatureSummer: false,
  hideFeatureWinter: false,
  hideCopyright: false,
  groupFeaturesInDetailView: true,
  hideLegend: false,
  ownCopyright: "",
  ownCoprightUrl: "",
  contactPersonLabel: "Ansprechpartner",
  subTitleInsteadOfDescription: false,
  fallbackPicture: { url: "" },
  searchFilterUiElements: {},
  isReport: false,
  season: "principalSeason",
  includedMappingFields: [],
  cities: [],
  showCitiesFilter: false,
  cardBorderRadius: 0,
  pictureSeason: "all",
  contentTeaserPois: [],
  showBackButtonTop: false,
  showLastChanged: true,
  mapPinIcon: "",
  showStateFilter: false,
  showFeatureFilter: false,
  showTextSearch: false,
  textSearchLabel: "Textsuche",
  showLogosInList: false,
  dsgvoLink: "",
  exhibitionEventId: "",
  hideExhibitionRoom: false,
  hideCategoryChips: false,
  dsgvoText:
    "Hier kann mit Deiner Einwilligung ein externer Inhalt angezeigt werden, der den redaktionellen Text ergänzt. Indem Du den Inhalt über „Akzeptieren und anzeigen“ aktivierst, kann der Anbieter der Videoplattform (z.B: YouTube) Informationen auf Deinem Gerät speichern oder abrufen und Deine personenbezogenen Daten erheben und verarbeiten, auch in Staaten außerhalb der EU mit einem niedrigeren Datenschutzniveau, worin Du ausdrücklich einwilligst. Die Einwilligung, kann von Dir wieder entzogen werden, indem Du Cookies & Cache löscht.",
  color: {
    "color-text": "#333",
    "color-primary": "#00636C",
    "color-contrast": "#fff",
    "color-hover": "#00636C",
    "color-secondary": "#5d7114",
    "color-accent": "#2468c9",
    "color-error": "#c55c52",
    "color-info": "#314d57",
    "color-success": "#00636C",
    "color-warning": "#c55c52",
    "map-pin-fill-color": "#257eca",
    "map-pin-stroke-color": "#2d5069",
    "map-pin-fill-color-active": "#c55c52",
    "map-pin-stroke-color-active": "#5d332f"
  },
  userPermission: "none",
  isApp: false,
  preFilterExcludePoiIds: [],
  preFilterExcludeCategoryGroupIds: [],
  preFilterExcludeCategoryIds: [],
  preFilterExcludeFeatureIds: []
};

export default {
  data: () => ({
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    dialog: false,
    editedKey: _.cloneDeep(defaultConfig),
    editedIndex: null,
    newConfig: false,
    apiKeyValid: false,
    changedDescription: [],
    menu: false,
    pois: [],
    allPois: []
  }),
  async mounted() {
    await this.fetchData();
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isPoiAdmin() {
      return this.currentUser?.scopes?.includes("role:poi_admin");
    },
    summerSeasonRange() {
      return this.config.summerSeasonRange;
    },
    categories() {
      return this.$store.state.categories;
    },
    apiKeys() {
      return this.$store.state.apiKeys;
    },
    isReadOnlyApiKey() {
      if (this.isAdmin) {
        return false;
      }
      if (this.editedKey.userPermission === "edit") {
        return false;
      }
      return true;
    },
    categoriesById() {
      return this.$store.state.categoriesById;
    },
    config() {
      const config = this.$store.state.globalConfig;
      if (!config || !Object.keys(config).length) this.newConfig = true;
      return config;
    },
    principal() {
      return this.$store.state.selectedPrincipal;
    },
    featureGroups() {
      return this.$store.state.featureGroups;
    },
    features() {
      return _.flatten(this.featureGroups.map(fg => fg.features));
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  },
  watch: {
    async principal() {
      await this.fetchData();
    },
    dialog(newState) {
      if (newState) {
        const defaultApiKeyConfig = this.getDefaultApiKeyConfig();
        if (!this.editedKey.color) {
          this.editedKey.color = defaultApiKeyConfig.color;
        } else {
          for (const key of Object.keys(defaultApiKeyConfig.color)) {
            if (!this.editedKey.color[key]) {
              this.editedKey.color[key] = defaultApiKeyConfig.color[key];
            }
          }
        }
        this.$nextTick(() => {
          this.$refs.editView?.setCodePreview();
        });
      }
    }
  },
  methods: {
    getPrincipalPaletteColors(moduleKey, widgetKey) {
      const colorPalette = this.$store.state.selectedPrincipal?.colorPalette;
      const colors = colorPalette?.[moduleKey]?.[widgetKey]?.colors;
      if (!Array.isArray(colors)) {
        return {};
      }
      return colors.reduce((acc, color) => {
        if (color?.key && color?.value) {
          acc[color.key] = color.value;
        }
        return acc;
      }, {});
    },
    getDefaultApiKeyConfig() {
      const baseConfig = _.cloneDeep(defaultConfig);
      baseConfig.color = {
        ...defaultConfig.color,
        ...this.getPrincipalPaletteColors("pois", "widget")
      };
      return baseConfig;
    },
    addChangedDescription(index) {
      if (!this.changedDescription.includes(index))
        this.changedDescription.push(index);
    },
    async addApiKey() {
      try {
        const defaultApiKeyConfig = this.getDefaultApiKeyConfig();
        const newApiKey = {
          apiKey: String.random(),
          config_ref: this.config._id,
          description: "",
          ...defaultApiKeyConfig
        };
        const headers = getTokenHeader();
        await axios.post(`${env.poi_api_client_url}apiKey/`, newApiKey, {
          headers
        });
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
        await this.$store.dispatch("getApiKeys");
      } catch (e) {
        this.createError();
      }
    },
    triggerShowSeason() {
      if (!this.config.showWinterSeason)
        this.config.currentSeason = "wholeYear";
      else this.config.currentSeason = "winter";
    },
    async removeApiKey(key) {
      try {
        const isConfirmed = await this.$confirm(
          "Wollen Sie diesen API Key wirklich löschen?",
          confirmWarningConfig
        );
        if (isConfirmed) {
          const fallbackImageId = key?.fallbackPicture?.id;
          if (fallbackImageId) await destroyFile("pois", fallbackImageId);
          const headers = getTokenHeader();
          await axios.delete(`${env.poi_api_client_url}apiKey/${key._id}`, {
            headers
          });
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getApiKeys");
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    async apiKeyPreview(apiKey) {
      if (!this.isReadOnlyApiKey) {
        const confirmRes = await this.$confirm(
          `Möchten Sie Änderungen speichern?`,
          confirmWarningConfig
        );
        if (confirmRes) {
          await this.saveKey();
        }
      }
      await this.showApiKey(apiKey);
    },
    async showApiKey(apiKey) {
      let widgetUrl =
        this.$store.state.selectedPrincipal?.additional_data?.poisWidgetUrl ??
        env.pois_widget_api_url;
      if (apiKey.newWidget) widgetUrl = env.pois_widget_api_url_v2;
      window.open(`${widgetUrl}pois?apiKey=${apiKey.apiKey}`, "_blank");
    },

    async copyApiKey(apiKey) {
      let clone = {
        ...apiKey,
        apiKey: String.random(),
        description: apiKey.description + " (Kopie)"
      };
      if (clone.fallbackPicture.url) {
        const newFile = await copyFileById(
          clone.fallbackPicture.id,
          getPictureUrlDatePath(clone.fallbackPicture.url)
        );
        clone.fallbackPicture = { ...clone.fallbackPicture, ...newFile };
      }
      delete clone._id;
      delete clone.updatedBy;
      delete clone.createdBy;
      try {
        const headers = getTokenHeader();
        const response = await axios.post(
          `${env.poi_api_client_url}apiKey/`,
          clone,
          {
            headers
          }
        );
        if (response.status === 201) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getApiKeys");
        } else {
          this.createError();
        }
      } catch (e) {
        this.createError();
      }
    },
    async fetchData() {
      try {
        await this.$store.dispatch("getCategories");
        await this.$store.dispatch("getFeatureGroupsForPois");
        await this.$store.dispatch("getGlobalConfig");
        await this.$store.dispatch("getMappingFields");
        await this.$store.dispatch("getApiKeys");
        await this.$store.dispatch("getAllUsers");
        await this.$store.dispatch("getRegions", {
          ignorePrincipalId: 1,
          listSearch: true
        });

        this.pois = await getPoisForConnectionMapping(
          this.selectedPrincipal.id
        );

        this.allPois = await getPoisForConnectionMapping([
          this.selectedPrincipal.id,
          ...(this.selectedPrincipal.subPrincipals.map(sp => sp.id) || [])
        ]);
      } catch (ex) {
        this.createError(ex);
      }
    },

    createError(error) {
      this.snackbar = true;
      this.snackbarText =
        "Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu oder versuchen Sie es später noch einmal";
      this.snackbarColor = "#c55c52";
      console.error(error);
    },

    editApiKey(index) {
      this.editedIndex = index;
      this.editedKey = Object.assign({}, this.getDefaultApiKeyConfig(), {
        ...this.apiKeys[index]
      });
      this.dialog = true;
    },
    closeKey() {
      this.editedIndex = null;
      this.editedKey = this.getDefaultApiKeyConfig();
      this.$refs.editView?.$refs?.fileInput?.reset();
      this.$refs.editView?.$refs?.logOverview?.resetLogs();
      this.dialog = false;
    },
    async saveKey(shouldCloseDialog) {
      if (this.isReadOnlyApiKey) {
        return;
      }
      if (this.apiKeyValid) {
        try {
          if (this?.editedKey?.fallbackPicture instanceof File)
            this.editedKey.fallbackPicture = await uploadFile(
              this.editedKey.fallbackPicture,
              this.config._id,
              "pois",
              this.config._id
            );
          if (this?.editedKey?.salesSettings.defaultPicture instanceof File)
            this.editedKey.salesSettings.defaultPicture = await uploadFile(
              this.editedKey.salesSettings.defaultPicture,
              this.config._id,
              "pois",
              this.config._id
            );
          const headers = getTokenHeader();
          const response = await axios.put(
            `${env.poi_api_client_url}apiKey/${this.editedKey._id}`,
            this.editedKey,
            {
              headers
            }
          );
          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gespeichert!"
            );
          }
          await this.$store.dispatch("getApiKeys");

          const logOverviewRef = this.$refs.editView?.$refs?.logOverview;
          const logsFetched = logOverviewRef?.logsFetched;
          logOverviewRef?.resetLogs();

          if (shouldCloseDialog) {
            this.closeKey();
          } else if (logsFetched) {
            logOverviewRef?.getLogs().then(null);
          }
        } catch (ex) {
          this.createError(ex);
        }
      } else this.createError("Bitte füllen sie alle Pflichtfelder aus");
    },
    async updateApiKeyDescription(index) {
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.poi_api_client_url}apiKey/${this.apiKeys[index]._id}`,
          this.apiKeys[index],
          { headers }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        }
      } catch (e) {
        this.createError();
      }
    },
    async save() {
      const headers = getTokenHeader();
      let method = "put";
      if (this.newConfig) method = "post";
      try {
        if (this.changedDescription.length) {
          await this.changedDescription.asyncForEach(
            async changedDescription => {
              await this.updateApiKeyDescription(changedDescription);
            }
          );
          await this.$store.dispatch("getApiKeys");
        }
        await axios[
          method
        ](
          `${env.poi_api_client_url}config/${this.selectedPrincipal?.id}/`,
          this.config,
          { headers }
        );
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert");
        await this.$store.dispatch("getGlobalConfig");
      } catch (ex) {
        this.createError();
      }
    },
    updateValue(value, key) {
      if (Array.isArray(value)) value = value[0];

      if (this.config?.export?.seasonFeatures)
        this.config.export.seasonFeatures[key] = value;
    },
    updateSalesFeatureValue(value, key) {
      if (Array.isArray(value)) value = value[0];

      if (this.config?.export?.salesFeatures)
        this.config.export.salesFeatures[key] = value;
    },
    checkPlz
  },
  components: {
    DateInput,
    InfoDialog,
    APIKeyEditView,
    APIKeyList,
    TreeViewSelection
  }
};
